var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDyduLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.55 266.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.06 69.42a100.84 100.84 0 01-95.8 132.14 77.18 77.18 0 01-24.77-4.08 100.81 100.81 0 0095.8 69.42v-47a77.26 77.26 0 0024.77-150.48",
    fill: "#ff5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29 65.34a77.22 77.22 0 0124.77 4.08A100.83 100.83 0 0077.26 0v47a77.26 77.26 0 00-24.77 150.48 100.82 100.82 0 0195.8-132.14",
    fill: "#7acbfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 100.78a100.65 100.65 0 00-5-31.36 77.24 77.24 0 00-24.78-4.08 100.82 100.82 0 00-95.73 132.14 77.18 77.18 0 0024.77 4.08A100.78 100.78 0 00178 100.78",
    fill: "#3636b9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDyduLogo);
export default __webpack_public_path__ + "static/media/dydu-logo.c16e93a651c802928172eb14032b6146.svg";
export { ForwardRef as ReactComponent };